module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3tLH45e0GQ0UAewiOyasKY-b81d540d5cad13444429f75de28be90d.jpg";